import styled from "styled-components";

import { colors, borderRadius } from "shared/styles/constants";

export const TypeIconContainer = styled.div`
  height: 45px;
  width: 45px;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${colors.grey1};
  border-radius: ${borderRadius.s};
  color: ${colors.grey5};

  position: relative;
`;

export const StatusIconContainer = styled.div`
  height: 20px;
  width: 20px;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${colors.grey1};
  border-radius: 50%;
  border: solid 1px ${colors.grey2};

  position: absolute;
  top: -5px;
  right: -5px;
`;
